import axios from "./axios"
export const logOut = async () => {
    const response = await axios.get('users/logout',
        {
            withCredentials: true
        }
    )
    return response.data
}